

<script lang="ts">

    export let icon: string;
    export let value: string | number;
    export let color: string = 'var(--color-secondary)';
    export let borderColor: string = 'var(--color-secondary)';
    export let bgColor: string = '#fff';

</script>

<style lang="scss">

    @use '../variables';

    .data-pill {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 2px solid;
        border-radius: 3px;
        padding: 0.5rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }   

    .icon {
        $size: 1.6rem;
        width: $size;
        height: $size;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .value {
        text-align: center;
        font-weight: bold;
    }

    @media (max-width: variables.$big-phone-width) and (max-height: variables.$big-phone-height) {

        .data-pill {
            justify-content: center;
            padding: 0.25rem;
        }
        
        .icon {
            
            display: none;
        }

    }

    @media (max-width: variables.$big-phone-width) and (min-height: variables.$big-phone-height) {

        .data-pill {
            justify-content: space-between;
            padding: 0.25rem 3rem;
        }

        .icon {
            display: block;
        }

    }

</style>

<div class="data-pill" style="border-color: {borderColor}; background-color: {bgColor}">
    <div class="icon">
        <img src="{icon}" alt="">
    </div>
    <div class="value" style="color: {color}">{value}</div>
</div>
